import lazyLoading from './lazyLoading'

export default {
  name: 'Dashboard',
  path: '/',
  system: 'business_sites',
  meta: {
    auth: true,
    icon: 'collapse-menu-arrows',
    link: 'dashboard/index'
  },
  component: lazyLoading('dashboard', true)
}
